import { fetchSiteProps } from '#/lib/sanity/fetchers/fetchSite';
import { Driving } from '#/components/Unwrapped/Driving';
import { Footer } from '#/components/Unwrapped/Footer';
import { Headshots } from '#/components/Unwrapped/Headshots';
import { Hero } from '#/components/Unwrapped/Hero';
import { Noise } from '#/components/Unwrapped/Noise';
import { CustomerStats } from '#/components/Unwrapped/Stats/CustomerStats';
import { ResponsibleAI } from '#/components/Unwrapped/Stats/ResponsibleAI';
import { AVP } from '#/components/Unwrapped/Testimonials/AVP';
import { IDC } from '#/components/Unwrapped/Testimonials/IDC';
import { Notion } from '#/components/Unwrapped/Testimonials/Notion';
import { Unifying } from '#/components/Unwrapped/Unifying';

export async function getStaticProps() {
  const props = await fetchSiteProps();
  const description =
    'See how leading companies honored billions of user choices, built AI-ready data foundations, and unlocked major efficiency gains in 2025.';
  const title = 'Data Rights Unwrapped 2025';

  return {
    props: {
      ...props,
      page: {
        description,
        title,
        openGraphDescription: description,
        openGraphTitle: title,
        openGraphImage: {
          _type: 'image',
          _id: 'image-12b287ac3a4c9b9e778c9287e3a4158240dae4d1-1200x630-png',
          url: 'https://cdn.sanity.io/images/ztw74qc4/production/12b287ac3a4c9b9e778c9287e3a4158240dae4d1-1200x630.png',
          width: 1200,
          height: 630,
          lqip: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACVUlEQVR4nC2R2U8TURyF5/8kqDz4gFESNUqBWXpn7uxLZ0qndN9YKjR1AYwYMCYENGnQFoQIkWBMoYLFdub+bt/NJCbn8XwP5zvMk0eXAjuU4oDjYMthXg8q5jCvD00xRBzRlEF97bx1tNc63nnR7Cjy78dT3fsTJxPjhxPjHYaf7WtyaGigK2Aq4GCSwKElhpgnAgsqHi7VT/faW7vt9Vq9jeK9h5MX98bbd8cO7owdMIgPVYnoGFQJZARyHCQeEAeIH0rijar0/PR5vfl5pbnvpc65uZupyR+PHxxysU7seYsReXBVUkqQlE4UEWQRpDjEOZDxtZvqeH7bMLqG3jOMKyz+ZWcG6Fm3Yv3aav5c3/zCKAiqPnxsQKMIjg6OSRMW2AZNOP1s4axYPptP9h0THDPahbjQFW93Fgff9q/bh0eMIkI2SV8v02oWEibNpEflYpRiDgr5oFoJFqtQKdFykWbTVJPBwkGjNNze6G1snDC2AZYWRcNgKJDxaaU0qpVpxOdHtcpoeWlUq9JqmRZyVFdAFIipDmzjEkunTLlAMz71bPAsSJjg2nTeBT9JU0manodchuYydMGnCymadEFXQwUPJHGA+D8CexXB1RJtLMObNVLKgiZHwkQhjHMBRkTFoOLIooxAU4JMtruy9r1QurCNW0MNGM+BjA/1xfDVapBPE4yAnyOz08PY01s2FgosCGx0uMCCofVfbn5tHb97++GT5/UkRBgVg6VD0iGeHagyQVzU42bCuemAm/2PiQIgnprmzfr2fvti9f3ujut1BQ7+ARpMv22yjF1zAAAAAElFTkSuQmCC',
          caption: null,
          roundedCorners: false,
          captionTextAlign: null,
        },
      },
    },
  };
}

export default function DataRightsUnwrapped() {
  return (
    <div className="relative z-5">
      <Noise />
      <Hero />
      <Headshots />
      <CustomerStats />
      <AVP />
      <ResponsibleAI />
      <IDC />
      <Driving />
      <Notion />
      <Unifying />
      <Footer />
    </div>
  );
}
